import { Text as TextNative } from "react-native";

export type TextNativeProps = TextNative["props"];
export default TextNative;
